import { z } from "zod";

// Create a placement label (a zone + slot pair with a human label). `slot` is a 32-bit integer
// (PG INT / C# int) — bound to [0, 2147483647] so the JSON-Schema gate rejects out-of-range values
// before C# model binding / PG insert. String bounds mirror the column widths (label VARCHAR(200)).
export const createPlacementRequestSchema = z.object({
  zone: z.string().min(1, "Zone is required").max(100),
  slot: z.number().int().min(0).max(2147483647),
  label: z.string().min(1, "Label is required").max(200),
  description: z.string().max(1000).nullable().optional(),
  active: z.boolean().optional(),
});
